<template>
  <div class="appointment-simple__row">
    <dr-icon
      :key="'medicalService-icon'"
      ref="medicalService-icon"
      name="medicalService"
      fill="gray"
      class="appointment-simple__row-icon"
    />

    <div class="appointment-simple__row-wrapper">
      <dr-field
        v-if="formData.medicalService.options.length > 0"
        :form.sync="formData"
        :field.sync="formData['medicalService']"
        :value.sync="formData['medicalService'].value"
        :id="'medicalService'"
        :ref="'medicalService'"
        :key="'appointment-simple-medicalService'"
        :class="[
          (formData['medicalService'].value > 0) && 'has-value',
          hasError && 'has-error'
        ]"
        class="appointment-simple__select"
        prefix="appointment-simple"
      />
    </div>
  </div>
</template>

<script>
import DrField from '@/components/form/field'
import { mapGetters } from 'vuex'

export default {
  name: 'DrAppointmentMedicalService',

  components: {
    DrField
  },

  props: {
    selectedMedicalService: {
      type: Number,
      required: false,
      default: () => null
    },

    hasError: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  data () {
    return {
      formData: {
        medicalService: {
          name: 'medicalService',
          options: [],
          placeholder: 'Escolha o exame ou procedimento',
          type: 'select',
          value: null
        }
      },
      medicalService: []
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },

  watch: {
    medicalService: {
      deep: true,
      initial: false,
      handler (v) {
        this.formData.medicalService.options = [...v]
      }
    },

    'formData.medicalService.value': {
      deep: false,
      initial: false,
      handler (v) {
        const selectedMedicalService = this.medicalService.find(e => e.id === v)
        this.$emit('on-select', selectedMedicalService)
      }
    }
  },

  created () {
    this.getmedicalService()
  },

  mounted () {
    if (this.selectedMedicalService) {
      this.formData.medicalService.value = this.selectedMedicalService
    }
  },

  methods: {
    getmedicalService () {
      const url = `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${this.office.id}/service`
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { data } = res.data

          if (data.length > 0) {
            data.forEach((exam) => {
              this.medicalService.push({
                id: exam.id, // id: exam['medical_service'].id,
                name: exam['medical_service'].name,
                price: exam.price
              })
            })
          } else {
            this.medicalService.push({
              id: 0,
              name: 'Nenhums serviço médico cadastrado',
              value: 0
            })
          }
        })
        .catch(err => console.log(err))
    }
  }
}
</script>
